import { useState } from "react";
import { ThumbsDown } from "react-feather";
import { useTranslation } from "react-i18next";
import { useAuth, useMessage } from "../../../../global-components/src";
import { errorMessage } from "../../../../global-components/src/utils/text";
import { api } from "../../../../services/api";

interface Props {
    id_post: number;
    id_user: number;
    tags?: string[] | null;
}

const NotInterested: React.FC<Props> = ({ id_post, id_user, tags }) => {
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setMessage } = useMessage();
    const { isAuthenticated, token, user } = useAuth();
    const { t } = useTranslation();

    if (!isAuthenticated || id_user === user?.id || !tags?.length || done) return null;

    const handleNotInterested = async () => {
        if (loading) return;
        setLoading(true);
        try {
            await api(token).post(`/posts/not-interested/${id_post}`);
            setDone(true);
            setMessage(t("post.actions.notInterestedSuccess"), "success");
        } catch (err) {
            setMessage(errorMessage(err), "error");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <li>
            <span className="dropdown-item cursor-pointer user-select-none" onClick={handleNotInterested}>
                <div className="div-icon-fix">
                    <div className="div-icon-block">
                        <ThumbsDown className="icon-config-post" />
                        {t("post.actions.notInterested")}
                    </div>
                </div>
            </span>
        </li>
    );
};

export default NotInterested;
